module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "font-style": "italic",
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_vm._v("La ventunenne Stephanie Stephenson è stata in una casa sicura per molti mesi insieme a tre guardie del corpo sexy. È l’unica testimone di un omicidio e loro l’hanno protetta da Santonio, il boss mafioso, che aveva giurato di vendicarsi se lei avesse osato testimoniare. Con le sue muscolose guardie del corpo è sempre stato tutto rigorosamente professionale e platonico. Ma ora il processo è finito e Stephanie è libera di andarsene.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Però le tre guardie del corpo hanno altri piani per Stephanie... piani molto licenziosi.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-a"
  }, [_vm._v("A")]), _vm._v("ltre storie di ")]), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Jasmine Black ")]), _vm._v("in italiano:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Serie Ménage:")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('li', [_vm._v("Sedotta da tre motociclisti ")]), _vm._v(" "), _c('li', [_vm._v("Impegnata con tre miliardari ")]), _vm._v(" "), _c('li', [_vm._v("Impegnata con tre dottori ")]), _vm._v(" "), _c('li', [_vm._v("Cavalcata da tre cowboy ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Serie Taken:")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('li', [_vm._v("Presa da due dottori ")]), _vm._v(" "), _c('li', [_vm._v("Sedotta da due biker ")]), _vm._v(" "), _c('li', [_vm._v("Presa da due miliardari ")]), _vm._v(" "), _c('li', [_vm._v("Sedotta da due boss ")]), _vm._v(" "), _c('li', [_vm._v("Presa da due personal trainers")]), _vm._v(" "), _c('li', [_vm._v("Presa da due pompieri")]), _vm._v(" "), _c('li', [_vm._v("Sedotta da due falegnami")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0